import { render, staticRenderFns } from "./HeadersCards.vue?vue&type=template&id=75e0a7a0&scoped=true&lang=pug"
import script from "./HeadersCards.vue?vue&type=script&lang=js"
export * from "./HeadersCards.vue?vue&type=script&lang=js"
import style0 from "./HeadersCards.vue?vue&type=style&index=0&id=75e0a7a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e0a7a0",
  null
  
)

export default component.exports